import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ApiService } 					from  '../api.service';
import { Router} 						from '@angular/router';

@Component({
  selector: 'app-outbound-delivery',
  templateUrl: './outbound-delivery.component.html',
  styleUrls: ['./outbound-delivery.component.css']
})
export class OutboundDeliveryComponent implements OnInit {

    options:any;
    data:any;
    orders:any;
    company:any;

    trackingNumber:any = null;
    resultsLength = 1;
    updateWeight = false;

    submitted = false;

    scannedItems:any = [];

    totalLoaded = 0;
    ordersCount = 0;

    form: FormGroup;
    inboundForm: FormGroup;
    deliveries: null;

    showTrackingInput = false;
    showWeightInput = false;

    // orders: Array<Object> = [];
    element: HTMLElement;
    failedOrders: Array<String> = [];



    constructor(
        private apiService: ApiService,
        private router: Router,
        private fb: FormBuilder
        ) { }


    get f() { return this.form.controls; }

    ngOnInit() {

        this.form = this.fb.group({
            plate_number: ['', []],
            // driver_phone: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
            company_id: ['', [Validators.required]],
            staff_id: ['', [Validators.required]],
            delivery_id: ['',     []],
            tracking_number: ['', []],
            package_weight: ['', [Validators.pattern(/^[.\d]+$/)]],
            // status_id: ['', []],
            // hub_location_id: ['', []],
            // start_date: ['', []],
            // end_date: ['', []],
        });

        this.index();
    }

    start() {

        this.submitted = true;

        if(this.form.valid) {

            if(this.form.controls['tracking_number'].value !== '' && this.form.controls['package_weight'].value === '' && this.updateWeight)
                setTimeout(()=>{
                    document.getElementById("package_weight").focus();
                },0);
            else {

                this.apiService.outboundDelivery(this.form.getRawValue()).subscribe(data => {

                    if (data.status) {
                        if(this.showTrackingInput)
                            this.totalLoaded++;

                        if('data' in data && 'deliveries' in data.data) {
                            this.deliveries = data.data.deliveries;

                            if(data.data.deliveries.length > 0) {
                                this.form.controls['delivery_id'].setValue(data.data.deliveries[0].id);                                
                            }

                            this.showTrackingInput = true;
                        }

                        if(this.showTrackingInput) {
                            setTimeout(()=>{
                                this.form.controls['tracking_number'].setValue('');
                                this.form.controls['package_weight'].setValue('');
                                
                                this.form.controls['plate_number'].disable();
                                this.form.controls['company_id'].disable();
                                this.form.controls['staff_id'].disable();
                                
                                document.getElementById("tracking_number").focus();
                                // this.loadDeliveryOrders(this.form.controls['delivery_id'].value);
                            },0);
                        }
                    }    
                    else {
                        alert(data.message);
                        this.form.controls['tracking_number'].setValue('');
                        this.form.controls['package_weight'].setValue('');

                        setTimeout(()=>{
                            document.getElementById("tracking_number").focus();
                        },0);
                    }
                });
            }
        }
    }



    index(): void {

        this.apiService.outboundDeliveryOptions().subscribe(data => {

            // console.log(data);
            this.options 		= data.data;
            // this.delivery         = data.data;
        });
    }

    toggleUpdateWeight(): void {
        this.updateWeight = !this.updateWeight;
        
        if(!this.updateWeight) {
            this.showWeightInput = false;
            this.form.controls['package_weight'].setValue('');
            
            setTimeout(()=>{
                document.getElementById("tracking_number").focus();
            },0);   
        }
        else {
            this.showWeightInput = true;
            
            if(this.form.controls['tracking_number'].value !== '') {
                this.form.controls['package_weight'].setValue('');
                setTimeout(()=>{
                    document.getElementById("package_weight").focus();
                },0);   
            }
            else 
                setTimeout(()=>{
                    document.getElementById("tracking_number").focus();
                },0);   
        }
    }

    onChange(event) {
        this.form.controls['delivery_id'].setValue(event.target.value);

        setTimeout(()=>{
            document.getElementById("tracking_number").focus();
        },0);

        this.showTrackingInput = true;

        if(event.target.value !== '')
            this.loadDeliveryOrders(event.target.value);
        else {
            this.orders = null
            this.ordersCount = 0;
        }
    }

    loadDeliveryOrders(id):void {

        if(id !== '') {
            this.orders         = null;
            this.ordersCount    = 0;

            this.apiService.outboundDeliveryOrders(id).subscribe(data => {

                this.orders         = data.data;
                if(this.orders)
                    this.ordersCount    = this.orders.length;
            });
        }
    }

    removeDeliveryOrder(id):void {

        let self = this;
        this.apiService.outboundDeliveryRemove(id).subscribe(data => {
            this.totalLoaded--;
            self.loadDeliveryOrders(this.form.controls['delivery_id'].value);
        });

    }

    finish() {
        this.submitted = false;
        this.showTrackingInput = false

        this.totalLoaded = 0;
        this.deliveries = null;

        this.form.controls['plate_number'].enable();
        this.form.controls['plate_number'].setValue('');
        this.form.controls['company_id'].enable();
        this.form.controls['company_id'].setValue('');
        this.form.controls['staff_id'].enable();
        this.form.controls['staff_id'].setValue('');
        this.form.controls['delivery_id'].setValue('');
        this.form.controls['tracking_number'].setValue('');
        this.form.controls['package_weight'].setValue('');

        this.data = null;
        this.orders = null;
        this.ordersCount = 0;

    }

    startBulk() {

      // this.orders = [];
      
      let values =  (<HTMLInputElement>document.getElementById("tnModel")).value.split("\n");

      if(values.length > 0) {
        let orders: Array<Object> = [];
        for (var i = values.length - 1; i >= 0; i--) {
          if(values[i] !== '')
            orders.push({'trackingNumber': values[i]});
        }

        // this.orders = this.orders.concat(orders);
          this.bulkOutbound(orders, 0);
      }
      
    }

    bulkOutbound(orders, index) {


        this.form.controls['tracking_number'].setValue(orders[index]['trackingNumber']);

           this.apiService.outboundDelivery(this.form.getRawValue()).subscribe(data => {

              if (data.status) {

                if('data' in data && 'deliveries' in data.data) {
                    this.deliveries = data.data.deliveries;

                    if(data.data.deliveries.length > 0) {
                        this.form.controls['delivery_id'].setValue(data.data.deliveries[0].id);                                
                    }
                }
              }  
              else {
                this.failedOrders.push(orders[index]['trackingNumber']+' | '+data.message); 
              }


              if((index+1) < orders.length) {
                      this.bulkOutbound(orders, index+1);  
                }
                else {
                  this.resetForm();
                  // this.loadDeliveryOrders(this.form.controls['delivery_id'].value);
              }

            });
    }

    resetForm() {
    
        this.form.controls['tracking_number'].setValue('');
        (<HTMLInputElement>document.getElementById("tnModel")).value = '';

        this.orders = [];
      }

  clearFailed() {

    this.failedOrders = [];
  }

    onCompanyChange(event) {
        
        // this.staff = null;
        this.form.controls['staff_id'].setValue('');
        this.company = this.options.companies.find(x => x.id == event.target.value);
    }
}
